






























































import { Session } from '../../utils/Session';
import { Component, Vue } from 'vue-property-decorator';
import MenuButton from './MenuButton.vue';
import MenuCard from './MenuCard.vue';

import { userTypeData } from '../../../src_server/entity/master/UserType';
@Component({ components: { MenuButton, MenuCard } })
export default class AdminMenuPage extends Vue {
  get isDA() {
    return Session.getSessionBuildingId() !== 'co01';
  }
  get isCO() {
    return Session.getSessionBuildingId() === 'co01';
  }

  get isOP() {
    return Session.getSessionUserType() === userTypeData.op;
  }

  get isOP_A() {
    return Session.getSessionUserType() === userTypeData.op_a;
  }
  get isDev() {
    return location.hostname.includes('localhost');
  }
}
